<template>
  <div>
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <v-icon color="primary" v-on="on" v-bind="attrs" @click="viewItem">
          mdi-eye
        </v-icon>
      </template>
      <span>View</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <v-icon color="primary" v-on="on" v-bind="attrs" @click="downloadItem">
          mdi-download
        </v-icon>
      </template>
      <span>Download</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <v-icon color="error" v-on="on" v-bind="attrs" @click="deleteItem">
          mdi-delete
        </v-icon>
      </template>
      <span>Delete Attachment</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  methods: {
    viewItem() {
      this.params.context.parentComponent.viewItemDoc(this.params.data);
    },
    downloadItem() {
   
      this.params.context.parentComponent.downloadDoc(this.params.data);
    },
    deleteItem() {
      this.params.context.parentComponent.deleteDocument(this.params.data);
    },
  },
};
</script>

<style></style>
